import UILoader from "./ui/UILoader";
import { UIBackdrop } from "./index";

function LoadingOverlay() {
  return (
    <UIBackdrop open invisible>
      <UILoader color="inherit" />
    </UIBackdrop>
  );
}

export default LoadingOverlay;
